import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createCheckoutSession, createPortalSession, getSubscriptionStatus } from '../../api/client';

interface SubscriptionState {
  status: 'free' | 'active' | 'canceled' | 'past_due';
  isPro: boolean;
  loading: boolean;
}

const initialState: SubscriptionState = {
  status: 'free',
  isPro: false,
  loading: false,
};

export const fetchSubscriptionStatus = createAsyncThunk(
  'subscription/fetchStatus',
  async () => {
    return await getSubscriptionStatus();
  }
);

export const initiateCheckout = createAsyncThunk(
  'subscription/initiateCheckout',
  async () => {
    const { checkoutUrl } = await createCheckoutSession();
    window.location.href = checkoutUrl;
  }
);

export const openPortal = createAsyncThunk(
  'subscription/openPortal',
  async () => {
    const { portalUrl } = await createPortalSession();
    window.location.href = portalUrl;
  }
);

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubscriptionStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action.payload.status as SubscriptionState['status'];
        state.isPro = action.payload.isPro;
      })
      .addCase(fetchSubscriptionStatus.rejected, (state) => {
        state.loading = false;
      })
      .addCase(initiateCheckout.pending, (state) => {
        state.loading = true;
      })
      .addCase(initiateCheckout.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default subscriptionSlice.reducer;
